import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  LinearProgress,
  MenuItem,
  Modal,
  Select,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripePaymentModal from "../Modal/StripePaymentModal";
import { setCookie } from "../utils/cookie";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import axios from 'axios';
import { useCallback } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import { Grid, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import Switch from '@mui/material/Switch';


const stripePromise = loadStripe(process.env.NEXT_PUBLIC_PAYMENT_PUBLIC_KEY);

const SignUpModal = ({ signUpModalState, setSignUpModalState }) => {
  const [formData, setFormData] = useState([
    {
      firstname: "",
      lastname: "",
      email: "",
      phone: null,
      gender: "",
      state: "",
      address: "",
      dob: "",
      time_of_birth: "",
      relationship_status: "",
      personality: "",
      strengths: "",
      lifeAreasFulfilling: "",
      lifeAreasImprovement: "",
      longTermGoals: "",
      majorLifeEvents: "",
      stressManagement: "",
      workLifeBalance: "",
      occupation: "",
      relationship_with_family: "",
      biggest_current_challenges: "",
      focus_on_specific_relationships: "",
      guidance_on_specific_decision: "",
      concerns_about_romantic_life: "",
      ongoing_projects_or_plans: "",
      social_life_fulfillment: "",
      spiritualPractices: "",
      selfDiscovery: "",
      externalInfluences: "",
      achieveFromReading: "",
      specificQuestions: "",
      goalsOutcomes: "",
      practicalSpiritualPref: "",
      mainConcern: "",

      additionalInfo: "",


    },
  ]);
  const [error, setError] = useState(Array(formData.length).fill({}));
  const [loader, setLoader] = useState(false);

  const [showPass, setShowPass] = useState(false);
  const [showConPass, setShowConPass] = useState(false);

  const [snackbarState, setSnackbarState] = useState(false);
  const [snackbarMassage, setSnackbarMassage] = useState("");

  const [userName, setUserName] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [stripeProcessing, setStripeProcessing] = useState(false);
  const [stripeError, setStripeError] = useState(null);
  const [isStripeModalOpen, setIsStripeModalOpen] = useState(false);

  const [stripeCustomerId, setStripeCustomerId] = useState(null);
  const [stripeSubscriptionId, setStripeSubscriptionId] = useState(null);
  const [stripeUserId, setStripeUserId] = useState(null);
  const [stripeUserEmail, setStripeUserEmail] = useState(null);

  const [amount_and_type, setAmount_And_type] = useState({
    type: "Single",
    amount: 19.95,
  });

  const StateArray = [
    {
      name: "Alabama",
      val: "AL",
    },
    {
      name: "Alaska",
      val: "AK",
    },
    {
      name: "Arizona",
      val: "AZ",
    },
    {
      name: "Arkansas",
      val: "AR",
    },
    {
      name: "California",
      val: "CA",
    },
    {
      name: "Colorado",
      val: "CO",
    },
    {
      name: "Connecticut",
      val: "CT",
    },
    {
      name: "Delaware",
      val: "DE",
    },
    {
      name: "Florida",
      val: "FL",
    },
    {
      name: "Georgia",
      val: "GA",
    },
    {
      name: "Hawaii",
      val: "HI",
    },
    {
      name: "Idaho",
      val: "ID",
    },
    {
      name: "Illinois",
      val: "IL",
    },
    {
      name: "Indiana",
      val: "IN",
    },
    {
      name: "Iowa",
      val: "IA",
    },
    {
      name: "Kansas",
      val: "KS",
    },
    {
      name: "Kentucky",
      val: "KY",
    },
    {
      name: "Louisiana",
      val: "LA",
    },
    {
      name: "Maine",
      val: "ME",
    },
    {
      name: "Maryland",
      val: "MD",
    },
    {
      name: "Massachusetts",
      val: "MA",
    },
    {
      name: "Michigan",
      val: "MI",
    },
    {
      name: "Minnesota",
      val: "MN",
    },
    {
      name: "Mississippi",
      val: "MS",
    },
    {
      name: "Missouri",
      val: "MO",
    },
    {
      name: "Montana",
      val: "MT",
    },
    {
      name: "Nebraska",
      val: "NE",
    },
    {
      name: "Nevada",
      val: "NV",
    },
    {
      name: "New Hampshire",
      val: "NH",
    },
    {
      name: "New Jersey",
      val: "NJ",
    },
    {
      name: "New Mexico",
      val: "NM",
    },
    {
      name: "New York",
      val: "NY",
    },
    {
      name: "North Carolina",
      val: "NC",
    },
    {
      name: "North Dakota",
      val: "ND",
    },
    {
      name: "Ohio",
      val: "OH",
    },
    {
      name: "Oklahoma",
      val: "OK",
    },
    {
      name: "Oregon",
      val: "OR",
    },
    {
      name: "Pennsylvania",
      val: "PA",
    },
    {
      name: "Rhode Island",
      val: "RI",
    },
    {
      name: "South Carolina",
      val: "SC",
    },
    {
      name: "South Dakota",
      val: "SD",
    },
    {
      name: "Tennessee",
      val: "TN",
    },
    {
      name: "Texas",
      val: "TX",
    },
    {
      name: "Utah",
      val: "UT",
    },
    {
      name: "Vermont",
      val: "VT",
    },
    {
      name: "Virgin Islands",
      val: "VI",
    },
    {
      name: "Virginia",
      val: "VA",
    },
    {
      name: "Washington",
      val: "WA",
    },
    {
      name: "West Virginia",
      val: "WV",
    },
    {
      name: "Wisconsin",
      val: "WI",
    },
    {
      name: "Wyoming",
      val: "WY",
    },
  ];

  const handleClose = () => {
    setSignUpModalState(false);
    setFormData([
      {
        firstname: "",
        lastname: "",
        email: "",
        phone: null,
        gender: "",
        state: "",
        address: "",
        occupation: "",
      },
    ]);
    setError([{}]);
    setLoader(false);
    setIsStripeModalOpen(false);
    setUserName("");
    setClientSecret("");
    setStripeProcessing(false);
    setStripeError(null);
    setStripeCustomerId(null);
    setStripeSubscriptionId(null);
    setStripeUserId(null);
    setStripeUserEmail(null);
    setAmount_And_type({ type: "Single", amount: 19.95 });
  };

  const handleCloseStripeModal = () => {
    setIsStripeModalOpen(false);
    setUserName("");
    setClientSecret("");
    setStripeProcessing(false);
    setStripeError(null);
    setStripeCustomerId(null);
    setStripeSubscriptionId(null);
    setStripeUserId(null);
    setStripeUserEmail(null);
  };

  const handelFormData = (e, index) => {
    const { name, value } = e.target;
    let obj = [...formData];
    let errorObj = [...error];
    obj[index][name] = value;
    setFormData(obj);

    if (errorObj[index]?.[name]) {
      delete errorObj[index][name];
      setError(errorObj);
    }
    if (stripeError) setStripeError(null);

    if (name === "relation") {
      if (errorObj[index]?.relation) {
        delete errorObj[index].relation;
        setError(errorObj);
      }
    }
    if (name === "gender") {
      if (errorObj[index]?.gender) {
        delete errorObj[index].gender;
        setError(errorObj);
      }
    }
    if (name === "state") {
      if (errorObj[index]?.state) {
        delete errorObj[index].state;
        setError(errorObj);
      }
    }
  };

  const validateForm = () => {
    let obj = [...formData];
    let errorObj = [...error];
    let isFormError = false;

    obj.forEach((item, index) => {
      errorObj[index] = {};

      if (index !== 0) {
        if (!item.relation) {
          errorObj[index].relation = "* Relation is required";
          isFormError = true;
        }
      }
      if (!item.firstname) {
        errorObj[index]["firstname"] = "* This field is required";
        isFormError = true;
      }
      if (!item.lastname) {
        errorObj[index]["lastname"] = "* This field is required";
        isFormError = true;
      }
      if (!item.email) {
        errorObj[index]["email"] = "* This field is required";
        isFormError = true;
      } else {
        const originalEmail = String(item.email);
        const trimmedEmail = originalEmail.trim();

        if (trimmedEmail === "") {
          errorObj[index]["email"] = "* This field is required (cannot be only spaces)";
          isFormError = true;
        } else if (originalEmail !== trimmedEmail) {
          errorObj[index]["email"] = "* Email should not have leading or trailing spaces.";
          isFormError = true;
        } else if (!/\S+@\S+\.\S+/.test(trimmedEmail)) {
          errorObj[index]["email"] = "* Invalid email format";
          isFormError = true;
        }
      }
      if (!item.phone) {
        errorObj[index]["phone"] = "* This field is required";
        isFormError = true;
      } else if (item.phone.length < 14) {
        errorObj[index]["phone"] = "Invalid Input";
        isFormError = true;
      }
      if (!item.gender) {
        errorObj[index].gender = "* Gender is required";
        isFormError = true;
      }
      if (!item.state) {
        errorObj[index].state = "* State is required";
        isFormError = true;
      }
      if (!item.city) {
        errorObj[index].city = "* City is required";
        isFormError = true;
      }
      if (!item.zip) {
        errorObj[index]["zip"] = "* This field is required";
        isFormError = true;
      } else if (item.zip.length < 5 || item.zip.length > 5) {
        errorObj[index]["zip"] = "Invalid Input";
        isFormError = true;
      }
      if (!item.address) {
        errorObj[index]["address"] = "* This field is required";
        isFormError = true;
      }
      if (!item.password) {
        errorObj[index]["password"] = "* Password is Required";
        isFormError = true;
      } else {
        const originalPassword = String(item.password);
        const trimmedPassword = originalPassword.trim();

        if (trimmedPassword === "") {
          errorObj[index]["password"] = "* Password is Required (cannot be only spaces)";
          isFormError = true;
        } else if (originalPassword !== trimmedPassword) {
          errorObj[index]["password"] = "* Password should not have leading or trailing spaces.";
          isFormError = true;
        } else if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).{8,15}$/.test(trimmedPassword)) {
          errorObj[index]["password"] = "* Invalid Password (8-15 chars, upper, lower, digit, symbol)";
          isFormError = true;
        }
      }
      if (!item.confirm_password) {
        errorObj[index]["confirm_password"] = "* This field is required";
        isFormError = true;
      } else {
        const originalConfirmPassword = String(item.confirm_password);
        const trimmedConfirmPassword = originalConfirmPassword.trim();
        const trimmedPassword = item.password ? String(item.password).trim() : "";

        if (trimmedConfirmPassword === "") {
          errorObj[index]["confirm_password"] = "* This field is required (cannot be only spaces)";
          isFormError = true;
        } else if (originalConfirmPassword !== trimmedConfirmPassword) {
          errorObj[index]["confirm_password"] = "* Confirm Password should not have leading or trailing spaces.";
          isFormError = true;
        } else if (trimmedPassword !== trimmedConfirmPassword) {
          errorObj[index]["confirm_password"] = "* Passwords do not match";
          isFormError = true;
        }
      }
    });

    setError(errorObj);
    return !isFormError;
  };
  // City autocomplete state and fetch logic

  const [cityOptions, setCityOptions] = useState([]);
  const [cityLatLon, setCityLatLon] = useState({});

  const fetchCitySuggestions = async (searchString) => {
    if (!searchString || searchString.length < 1) {
      setCityOptions([]);
      return;
    }

    try {
      const res = await axios.post(
        `https://d36fwfwo4vnk9h.cloudfront.net/astro-ai/fetch_city_with_latLon`,
        {
          searchcondition: { search_string: searchString }
        }
      );

      if (res.data?.status === "success" && Array.isArray(res.data.res)) {
        console.log("City suggestions fetched:", res.data.res);
        setCityOptions(res.data.res); // Each item has .val and .key
      } else {
        setCityOptions([]);
      }
    } catch (err) {
      console.error("Error fetching city suggestions:", err);
      setCityOptions([]);
    }
  };
  useEffect(() => {
    fetchCitySuggestions("a")
  }, [])

  // Debounce for city autocomplete
  function debounce(func, delay) {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }
  const debouncedFetchCitySuggestions = useCallback(debounce(fetchCitySuggestions, 400), []);

  // Fetch city lat/lon if needed (optional)
  const fetchCityLatLon = async (cityVal) => {
    // You can implement this if you want to fetch lat/lon for selected city
    // setCityLatLon({ lat: ..., lon: ... });
  };


  const handleSignupAndInitiatePayment = async () => {
    const requiredFields = [
      "firstname", "lastname", "email", "phone", "gender", "state", "address", "city", "zip", "occupation", "password", "confirm_password"
    ];

    const filteredFormData = formData.filter(item =>
      requiredFields.every(field => item[field] && String(item[field]).trim() !== "")
    );

    if (filteredFormData.length === 0) {
      setSnackbarState(true);
      setSnackbarMassage("No valid entries to submit. Please check your form.");
      return;
    }
    if (!validateForm()) {
      setSnackbarState(true);
      setSnackbarMassage("Please fill the necessary details in the form.");
      return;
    }

    setLoader(true);
    setStripeError(null);

    try {
      // let signupPayload = [...formData];
      let signupPayload = filteredFormData.map(obj => {
        const cleaned = {};
        Object.keys(obj).forEach(key => {
          // Only add if value is not "", null, undefined, or false
          if (
            obj[key] !== "" &&
            obj[key] !== null &&
            obj[key] !== undefined &&
            obj[key] !== false
          ) {
            cleaned[key] = obj[key];
          }
        });
        return cleaned;
      });
      let localAmount = 19.95;
      let localRelation = "Single";
      if (signupPayload.length > 2) {
        localAmount = 39.95;
        localRelation = "Family";
      } else if (signupPayload.length > 1) {
        localAmount = 29.95;
        localRelation = "Couple";
      }

      signupPayload.forEach((obj, index) => {
        obj.mandalism = true;
        obj.user_type = "is_Perennial_Mandalism";
        if (index === 0) {
          obj.membership_type = localRelation;
          obj.membership_amount = localAmount;
          obj.is_main_user = true;
        }
      });

      console.log("Signuppayload", signupPayload);
      return

      const signupReq = await fetch(
        `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}user/signup`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(signupPayload),
        }
      );

      const signupRes = await signupReq.json();

      if (
        signupRes.status === "success" &&
        signupRes.results?.main_id &&
        signupRes.results?.main_email
      ) {
        console.log("Signup successful:", signupRes.results);
        setStripeUserId(signupRes.results.main_id);
        setStripeUserEmail(signupRes.results.main_email);
        setSnackbarState(true);
        setSnackbarMassage("Signup successful! Proceeding to payment...");

        try {
          console.log("Calling subscription-payment...");
          const paymentPayload = {
            customer_id: signupRes.results.main_id,
            email: signupRes.results.main_email,
          };

          const paymentReq = await fetch(
            `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}cart_management/subscription-payment`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(paymentPayload),
            }
          );

          const paymentRes = await paymentReq.json();

          if (paymentRes.status === "success" && paymentRes.clientSecret) {
            console.log("Subscription initiation successful:", paymentRes);
            setUserName(signupPayload[0].firstname + " " + signupPayload[0].lastname);
            setClientSecret(paymentRes.clientSecret);
            setStripeCustomerId(paymentRes.customerId);
            setStripeSubscriptionId(paymentRes.subscriptionId);
            setIsStripeModalOpen(true);
            setSnackbarState(true);
            setSnackbarMassage("Please enter your payment details.");
          } else {
            setStripeError(
              "Failed to set up subscription payment. Please try again."
            );
            setSnackbarState(true);
            setSnackbarMassage("Failed to set up subscription payment.");
          }
        } catch (paymentError) {
          setStripeError("An network error occurred while setting up payment.");
          setSnackbarState(true);
          setSnackbarMassage(
            "An error occurred setting up payment. Please try again."
          );
        }
      } else {
        if (signupRes.message.includes("already exists")) {
          setSnackbarState(true);
          setSnackbarMassage(signupRes.message);
        } else {
          setStripeError(
            "Signup failed. Please check your details and try again."
          );
          setSnackbarState(true);
          setSnackbarMassage("Signup failed.");
        }
      }
    } catch (signupError) {
      setStripeError("An network error occurred during signup.");
      setSnackbarState(true);
      setSnackbarMassage("An error occurred during signup. Please try again.");
    } finally {
      setLoader(false);
    }
  };

  const handleStripeSubmit = async (stripe, elements) => {
    setStripeProcessing(true);
    setStripeError(null);

    if (
      stripeCustomerId &&
      stripeSubscriptionId &&
      stripeUserId &&
      stripeUserEmail
    ) {
      const cookiebody = {
        customer_id: stripeCustomerId,
        subscription_id: stripeSubscriptionId,
        user_id: stripeUserId,
        email: stripeUserEmail,
        ...(userName && { name: userName }),
      };
      try {
        console.log("Setting stripeUserDetails cookie:", cookiebody);
        setCookie("stripeUserDetails", JSON.stringify(cookiebody), {
          path: "/",
        });
      } catch (cookieError) {
        setStripeError(
          "Could not save user details locally. Please try again."
        );
        setSnackbarState(true);
        setSnackbarMassage("Error saving user details. Payment not attempted.");
        setStripeProcessing(false);
        return;
      }
    } else {
      setStripeError(
        "Required user/subscription details are missing. Cannot proceed."
      );
      setSnackbarState(true);
      setSnackbarMassage("Cannot proceed: Missing required details.");
      setStripeProcessing(false);
      return;
    }

    const returnUrl = `${window.location.origin}/stripe-success-page`;

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: returnUrl,
      },
      redirect: "always",
    });

    if (error) {
      if (error.type === "card_error" || error.type === "validation_error") {
        setStripeError(error.message);
        setSnackbarState(true);
        setSnackbarMassage(`Payment failed: ${error.message}`);
      } else {
        setStripeError("An unexpected error occurred during payment.");
        setSnackbarState(true);
        setSnackbarMassage("An unexpected error occurred. Please try again.");
      }
      setStripeProcessing(false);
    }
  };

  const addFields = () => {
    let obj = [...formData];
    obj.push({
      relation: "",
      firstname: "",
      lastname: "",
      email: "",
      phone: null,
      address: "",
    });
    setFormData(obj);
  };

  const removePartner = (index) => {
    let updatedFormData = [...formData];
    updatedFormData.splice(index, 1);
    setFormData(updatedFormData);
    let updatedError = [...error];
    updatedError.splice(index, 1);
    setError(updatedError);
  };

  const phoneFormatting = (event, index) => {
    if (event.target.value.split("").length <= 14) {
      let formatted = formatPhoneText(event.target.value);
      let name = event.target.name;
      let obj = [...formData];
      obj[index][name] = formatted;
      setFormData(obj);
    }
  };

  function formatPhoneText(value) {
    value = value.trim().replaceAll("-", "");
    value = value.trim().replaceAll("(", "");
    value = value.trim().replaceAll(")", "");
    value = value.trim().replaceAll(" ", "");
    if (value.length > 3 && value.length <= 6)
      value = "(" + value.slice(0, 3) + ")" + " " + value.slice(3);
    else if (value.length > 6)
      value =
        "(" +
        value.slice(0, 3) +
        ")" +
        " " +
        value.slice(3, 6) +
        "-" +
        value.slice(6);
    return value;
  }

  useEffect(() => {
    const memberCount = formData.length;
    let newAmount = 19.95;
    let newType = "Single";
    let familyFound = false;
    let coupleFound = false;

    if (memberCount > 2) {
      newAmount = 39.95;
    } else if (memberCount === 2) {
      newAmount = 29.95;
    }

    if (memberCount > 1) {
      for (let i = 1; i < formData.length; i++) {
        if (formData[i].relation?.toLowerCase() === "family") {
          familyFound = true;
          break;
        } else if (formData[i].relation?.toLowerCase() === "couple") {
          coupleFound = true;
        }
      }

      if (familyFound) {
        newType = "Family";
      } else if (coupleFound) {
        newType = "Couple";
      } else {
        newType = memberCount > 2 ? "Family" : "Couple";
      }
    }

    setAmount_And_type({ type: newType, amount: newAmount });

  }, [formData]);

  const appearance = {
    theme: "stripe",
    variables: {
      colorPrimary: "#0570de",
    },
    rules: {
      ".Label": {
        color: "#fff",
      },
      ".TermsText": {
        color: "#fff",
      },
      ".p-BankView--text": {
        color: "#fff",
      },
    },
  };
  const stripeOptions = {
    clientSecret,
    appearance,
  };

  return (
    <>
      <div>
        <Modal
          open={signUpModalState}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="banner_modal_main banner_modal_main_new banner_modal_main_new1"
        >

          <div className="main_wrpr_finddivine">
            <span className="close_btn" onClick={handleClose}>
              <CloseIcon />
            </span>

            <Box className="banner_modal_box_new banner_modal_box_neww">
              <Typography
                id="modal-modal-description" component="div"
                sx={{ mt: 2 }}
                className="modal_banner_new"
              >
                <div className="sub_modal_banner_new">
                  <div className="gred_txt">
                    <h3>
                      <span>Become a Part of Perennial Mandalism </span>
                    </h3>
                  </div>

                  <p className="notification_message">Fields marked with an asterisk (*) are required.</p>

                  <div className="mdl_form_sec">
                    <form
                      className="mdl_form"
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleSignupAndInitiatePayment();
                      }}
                    >
                      {formData &&
                        formData.map((item, index) => {
                          return (
                            <div key={index}>
                              {index != 0 && (
                                <div className="gred_txt">
                                  <h3>
                                    <span>Add another member</span>
                                  </h3>

                                  <div className="btn_wrpr add_partner_button">
                                    <Tooltip title="Remove Partner">
                                      <IconButton
                                        onClick={() => removePartner(index)}
                                      >
                                        <RemoveIcon />
                                      </IconButton>
                                    </Tooltip>
                                  </div>
                                </div>
                              )}

                              {index != 0 && (
                                <FormControl className="from_input form_field_wrapperstate full_filed">
                                  <InputLabel id="demo-simple-select-helper-label">
                                    {" "}
                                    * Relation
                                  </InputLabel>
                                  <Select
                                    className="contact_select_menu"
                                    id="demo-simple-select-helper"
                                    label="* Relation"
                                    name="relation"
                                    value={item.relation}
                                    onChange={(e) => handelFormData(e, index)}
                                    helperText={error[index]?.relation}
                                  >
                                    <MenuItem
                                      className="contact_menu_item"
                                      value="Couple"
                                    >
                                      Partner/Couple
                                    </MenuItem>
                                    <MenuItem
                                      className="contact_menu_item"
                                      value="Family"
                                    >
                                      Family
                                    </MenuItem>
                                  </Select>
                                  {error[index]?.relation && (
                                    <FormHelperText id="my-helper-text">
                                      {error[index]?.relation}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              )}

                              <div className="mdl_form_flex perennial_mandalism_form perenial_flex_class">
                                <TextField
                                  className="from_input form_field_wrapperfname"
                                  value={item.firstname}
                                  onChange={(e) => handelFormData(e, index)}
                                  error={!!error[index]?.firstname}
                                  helperText={error[index]?.firstname}
                                  id="outlined-basic"
                                  name="firstname"
                                  variant="outlined"
                                  label="* First Name"
                                  onKeyDown={() => {
                                    let obj = [...error];
                                    if (obj[index]?.firstname) {
                                      delete obj[index]["firstname"];
                                    }
                                    setError(obj);
                                  }}
                                />

                                <TextField
                                  className="from_input form_field_wrapperfname"
                                  value={item.lastname}
                                  onChange={(e) => handelFormData(e, index)}
                                  error={!!error[index]?.lastname}
                                  helperText={error[index]?.lastname}
                                  id="outlined-basic"
                                  name="lastname"
                                  variant="outlined"
                                  label="* Last Name"
                                  onKeyDown={() => {
                                    let obj = [...error];
                                    if (obj[index]?.lastname) {
                                      delete obj[index]["lastname"];
                                    }
                                    setError(obj);
                                  }}
                                />

                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                  <DatePicker
                                    label="* Date of Birth"
                                    value={item.dob ? dayjs(item.dob) : null}
                                    onChange={(newValue) => {
                                      handelFormData(
                                        { target: { name: 'dob', value: newValue } },
                                        index
                                      );
                                    }}
                                    slotProps={{
                                      textField: {
                                        variant: 'outlined',
                                        className: 'from_input form_field_wrapperfname',
                                        error: !!error[index]?.dob,
                                        helperText: error[index]?.dob,
                                        onKeyDown: () => {
                                          let obj = [...error];
                                          if (obj[index]?.dob) delete obj[index]['dob'];
                                          setError(obj);
                                        },
                                      },
                                    }}
                                  />
                                </LocalizationProvider>


                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                  <TimePicker
                                    label="* Time of Birth"
                                    // Ensure the TimePicker displays only the time from your stored string
                                    value={
                                      item.time_of_birth
                                        ? dayjs(item.time_of_birth, ['hh:mm A', dayjs.ISO_8601])
                                        : null
                                    }
                                    onChange={(newValue) => {
                                      const onlyTime = newValue ? dayjs(newValue).format('hh:mm A') : '';

                                      console.log('Saving only time:', onlyTime); // ✅ Should be like "02:30 PM"

                                      handelFormData(
                                        {
                                          target: {
                                            name: 'time_of_birth',
                                            value: onlyTime,
                                          },
                                        },
                                        index
                                      );
                                    }}
                                    slotProps={{
                                      textField: {
                                        variant: 'outlined',
                                        className: 'from_input form_field_wrapperfname',
                                        error: !!error[index]?.time_of_birth,
                                        helperText: error[index]?.time_of_birth,
                                        onKeyDown: () => {
                                          let obj = [...error];
                                          if (obj[index]?.time_of_birth) delete obj[index]['time_of_birth'];
                                          setError(obj);
                                        },
                                      },
                                    }}
                                  />
                                </LocalizationProvider>




                                <TextField
                                  className="from_input form_field_wrapperfname"
                                  value={item.email}
                                  onChange={(e) => handelFormData(e, index)}
                                  error={!!error[index]?.email}
                                  helperText={error[index]?.email}
                                  id="outlined-basic"
                                  name="email"
                                  variant="outlined"
                                  label="* Email"
                                  onKeyDown={() => {
                                    let obj = [...error];
                                    if (obj[index]?.email) {
                                      delete obj[index]["email"];
                                    }
                                    setError(obj);
                                  }}
                                />

                                <TextField
                                  onKeyPress={(e) => {
                                    if (error[index]?.phone) {
                                      delete error[index]["phone"];
                                    }
                                    if (e.which < 48 || e.which > 57) {
                                      e.preventDefault();
                                    }
                                  }}
                                  value={item.phone}
                                  onChange={(e) => phoneFormatting(e, index)}
                                  error={!!error[index]?.phone}
                                  helperText={error[index]?.phone}
                                  className="from_input form_field_wrapperfname"
                                  id="outlined-basic"
                                  name="phone"
                                  variant="outlined"
                                  label="* Phone"
                                />

                                <FormControl
                                  className="from_input form_field_wrapperstate"
                                  error={!!error[index]?.gender}
                                >
                                  <InputLabel id="demo-simple-select-helper-label">
                                    {" "}
                                    * Gender{" "}
                                  </InputLabel>

                                  <Select
                                    className="contact_select_menu"
                                    id="demo-simple-select-helper"
                                    label="* Gender"
                                    name="gender"
                                    value={item.gender}
                                    onChange={(e) => handelFormData(e, index)}
                                  >
                                    <MenuItem
                                      className="contact_menu_item"
                                      value="male"
                                    >
                                      Male
                                    </MenuItem>
                                    <MenuItem
                                      className="contact_menu_item"
                                      value="female"
                                    >
                                      Female
                                    </MenuItem>
                                    <MenuItem
                                      className="contact_menu_item"
                                      value="other"
                                    >
                                      Other
                                    </MenuItem>
                                  </Select>

                                  {error[index]?.gender && (
                                    <FormHelperText id="my-helper-text">
                                      {error[index]?.gender}
                                    </FormHelperText>
                                  )}
                                </FormControl>

                                <FormControl
                                  className="from_input form_field_wrapperstate"
                                  error={!!error[index]?.state}
                                >
                                  <InputLabel id="demo-simple-select-helper-label">
                                    {" "}
                                    * State{" "}
                                  </InputLabel>
                                  <Select
                                    className="contact_select_menu"
                                    id="demo-simple-select-helper"
                                    label="* State"
                                    name="state"
                                    value={item.state}
                                    onChange={(e) => handelFormData(e, index)}
                                  >
                                    {StateArray &&
                                      StateArray.map((itemd, index) => {
                                        return (
                                          <MenuItem
                                            key={index}
                                            className="contact_menu_item"
                                            value={itemd.val}
                                          >
                                            {" "}
                                            {itemd.name}{" "}
                                          </MenuItem>
                                        );
                                      })}
                                  </Select>
                                  {error[index]?.state && (
                                    <FormHelperText id="my-helper-text">
                                      {error[index]?.state}
                                    </FormHelperText>
                                  )}
                                </FormControl>

                                <Autocomplete
                                  freeSolo
                                  className="from_input form_field_wrapperfname"
                                  options={cityOptions}
                                  getOptionLabel={(option) => (typeof option === 'string' ? option : option.val)}
                                  inputValue={item.city}
                                  onInputChange={(event, newInputValue) => {
                                    handelFormData({ target: { name: 'city', value: newInputValue } }, index);
                                    debouncedFetchCitySuggestions(newInputValue);
                                  }}
                                  onChange={async (event, selectedOption) => {
                                    const selectedVal = typeof selectedOption === 'string' ? selectedOption : selectedOption?.val;

                                    handelFormData({ target: { name: 'city', value: selectedVal || '' } }, index);

                                    let obj = [...error];
                                    if (obj[index]?.city) {
                                      delete obj[index]["city"];
                                      setError(obj);
                                    }

                                    if (selectedVal) {
                                      await fetchCityLatLon(selectedVal);
                                    }
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="* City"
                                      error={!!error[index]?.city}
                                      helperText={error[index]?.city}
                                    />
                                  )}
                                />
                                <TextField
                                  onKeyPress={(e) => {
                                    if (error[index]?.zip) {
                                      delete error[index]["zip"];
                                    }
                                    if (e.which < 48 || e.which > 57) {
                                      e.preventDefault();
                                    }
                                  }}
                                  value={item.zip}
                                  onChange={(e) => handelFormData(e, index)}
                                  error={!!error[index]?.zip}
                                  helperText={error[index]?.zip}
                                  className="from_input form_field_wrapperfname"
                                  id="outlined-basic"
                                  name="zip"
                                  variant="outlined"
                                  label="* Zip"
                                />

                                <TextField
                                  value={item.occupation || ""}
                                  onChange={(e) => handelFormData(e, index)}
                                  error={!!error[index]?.occupation}
                                  helperText={error[index]?.occupation}
                                  className="from_input form_field_wrapperfname"
                                  id="outlined-basic"
                                  variant="outlined"
                                  label="* Occupation"
                                  name="occupation"
                                  onKeyDown={() => {
                                    let obj = [...error];
                                    if (obj[index]?.occupation) {
                                      delete obj[index]["occupation"];
                                    }
                                    setError(obj);
                                  }}
                                />

                                <TextField
                                  value={item.address}
                                  onChange={(e) => handelFormData(e, index)}
                                  error={!!error[index]?.address}
                                  helperText={error[index]?.address}
                                  className="from_input  form_field_wrapperfname"
                                  id="outlined-basic"
                                  variant="outlined"
                                  label="* Full Address"
                                  name="address"
                                  onKeyDown={() => {
                                    let obj = [...error];
                                    if (obj[index]?.address) {
                                      delete obj[index]["address"];
                                    }
                                    setError(obj);
                                  }}
                                />


                                <Grid item xs={12}>
                                  <Typography
                                    variant="subtitle1"
                                    sx={{
                                      color: '#ff9800',
                                      fontWeight: 'bold',
                                      marginBottom: '10px',
                                    }}
                                  >
                                    Relationship Status
                                  </Typography>

                                  <RadioGroup
                                    row
                                    name="relationship_status"
                                    value={item.relationship_status || ""}
                                    onChange={(e) => {
                                      handelFormData({ target: { name: 'relationship_status', value: e.target.value } }, index);
                                    }}
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '20px',
                                    }}
                                  >
                                    {['Single', 'Married', 'Separated', 'Divorced', 'Widowed'].map((status) => (
                                      <FormControlLabel
                                        key={status}
                                        value={status}
                                        control={
                                          <Radio
                                            sx={{
                                              color: '#ff9800',
                                              '&.Mui-checked': { color: '#ff9800' },
                                            }}
                                          />
                                        }
                                        label={status}
                                        sx={{
                                          color: '#fff',
                                          margin: 0,
                                          display: 'flex',
                                          alignItems: 'center',
                                          '.MuiFormControlLabel-label': {
                                            fontSize: '14px',
                                            lineHeight: '1',
                                          },
                                        }}
                                      />
                                    ))}
                                  </RadioGroup>
                                </Grid>

                                <div className="full_filed password_sec password_sec">
                                  <Typography
                                    variant="subtitle1"
                                    sx={{ color: '#ff9800', fontWeight: 'bold', marginBottom: '10px' }}
                                  >
                                    Personality and Life
                                  </Typography>
                                </div>
                                <TextField
                                  value={item.personality || ""}
                                  onChange={(e) => handelFormData(e, index)}
                                  error={!!error[index]?.personality}
                                  helperText={error[index]?.personality}
                                  className="from_input form_field_wrapperfname"
                                  id="outlined-basic"
                                  variant="outlined"
                                  label="Describe Your Personality"
                                  name="personality"
                                  onKeyDown={() => {
                                    let obj = [...error];
                                    if (obj[index]?.personality) {
                                      delete obj[index]["personality"];
                                    }
                                    setError(obj);
                                  }}
                                />
                                <TextField
                                  value={item.strengths}
                                  onChange={(e) => handelFormData(e, index)}
                                  error={!!error[index]?.strengths}
                                  helperText={error[index]?.strengths}
                                  className="from_input  form_field_wrapperfname"
                                  id="outlined-basic"
                                  variant="outlined"
                                  label="Primary Strengths and Talents"
                                  name="strengths"
                                  onKeyDown={() => {
                                    let obj = [...error];
                                    if (obj[index]?.strengths) {
                                      delete obj[index]["strengths"];
                                    }
                                    setError(obj);
                                  }}
                                />
                                <TextField
                                  value={item.lifeAreasFulfilling}
                                  onChange={(e) => handelFormData(e, index)}
                                  error={!!error[index]?.lifeAreasFulfilling}
                                  helperText={error[index]?.lifeAreasFulfilling}
                                  className="from_input  form_field_wrapperfname"
                                  id="outlined-basic"
                                  variant="outlined"
                                  label="Life Areas Currently Fulfilling"
                                  name="lifeAreasFulfilling"
                                  onKeyDown={() => {
                                    let obj = [...error];
                                    if (obj[index]?.lifeAreasFulfilling) {
                                      delete obj[index]["lifeAreasFulfilling"];
                                    }
                                    setError(obj);
                                  }}
                                />
                                <TextField
                                  value={item.lifeAreasImprovement}
                                  onChange={(e) => handelFormData(e, index)}
                                  error={!!error[index]?.lifeAreasImprovement}
                                  helperText={error[index]?.lifeAreasImprovement}
                                  className="from_input  form_field_wrapperfname"
                                  id="outlined-basic"
                                  variant="outlined"
                                  label="Life Areas Needing Improvement"
                                  name="lifeAreasImprovement"
                                  onKeyDown={() => {
                                    let obj = [...error];
                                    if (obj[index]?.lifeAreasImprovement) {
                                      delete obj[index]["lifeAreasImprovement"];
                                    }
                                    setError(obj);
                                  }}
                                />
                                <TextField
                                  value={item.longTermGoals}
                                  onChange={(e) => handelFormData(e, index)}
                                  error={!!error[index]?.longTermGoals}
                                  helperText={error[index]?.longTermGoals}
                                  className="from_input  form_field_wrapperfname"
                                  id="outlined-basic"
                                  variant="outlined"
                                  label="Long-Term Goals and Aspirations"
                                  name="longTermGoals"
                                  onKeyDown={() => {
                                    let obj = [...error];
                                    if (obj[index]?.longTermGoals) {
                                      delete obj[index]["longTermGoals"];
                                    }
                                    setError(obj);
                                  }}
                                />
                                <TextField
                                  value={item.majorLifeEvents}
                                  onChange={(e) => handelFormData(e, index)}
                                  error={!!error[index]?.majorLifeEvents}
                                  helperText={error[index]?.majorLifeEvents}
                                  className="from_input  form_field_wrapperfname"
                                  id="outlined-basic"
                                  variant="outlined"
                                  label="Major Life Events/Experiences"
                                  name="majorLifeEvents"
                                  onKeyDown={() => {
                                    let obj = [...error];
                                    if (obj[index]?.majorLifeEvents) {
                                      delete obj[index]["majorLifeEvents"];
                                    }
                                    setError(obj);
                                  }}
                                />
                                <div style={{ marginTop: '20px', display: 'flex', gap: '40px' }}>
                                  {/* Stress Management */}
                                  <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}> {/* Added flexDirection column for the overall item container */}
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}> {/* New flex container for text and switch */}
                                      <Typography style={{ color: 'white', marginRight: '10px' }}> {/* Added marginRight for spacing */}
                                        Stress Management (Do you find it challenging to handle stress?)
                                      </Typography>
                                      <Switch
                                        checked={item.stressManagement || false}
                                        onChange={(e) =>
                                          handelFormData(
                                            { target: { name: 'stressManagement', value: e.target.checked } },
                                            index
                                          )
                                        }
                                        sx={{
                                          '& .MuiSwitch-switchBase.Mui-checked': {
                                            color: '#ff9800',
                                          },
                                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                            backgroundColor: '#ff9800',
                                          },
                                        }}
                                      />
                                    </div>
                                  </div>

                                  {/* Work-Life Balance */}
                                  <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}> {/* Added flexDirection column for the overall item container */}
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}> {/* New flex container for text and switch */}
                                      <Typography style={{ color: 'white', marginRight: '10px' }}> {/* Added marginRight for spacing */}
                                        Work-Life Balance (Do you feel you have a good balance? Yes/No)
                                      </Typography>
                                      <Switch
                                        checked={item.workLifeBalance || false}
                                        onChange={(e) =>
                                          handelFormData(
                                            { target: { name: 'workLifeBalance', value: e.target.checked } },
                                            index
                                          )
                                        }
                                        sx={{
                                          '& .MuiSwitch-switchBase.Mui-checked': {
                                            color: '#ff9800',
                                          },
                                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                            backgroundColor: '#ff9800',
                                          },
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>



                                <div className="full_filed password_sec password_sec">
                                  <Typography
                                    variant="subtitle1"
                                    sx={{ color: '#ff9800', fontWeight: 'bold', marginBottom: '10px' }}
                                  >
                                    Relationships and Social Dynamics
                                  </Typography>
                                  <TextField
                                    value={item.relationship_with_family}
                                    onChange={(e) => handelFormData(e, index)}
                                    error={!!error[index]?.relationship_with_family}
                                    helperText={error[index]?.relationship_with_family}
                                    className="from_input  form_field_wrapperfname"
                                    id="outlined-basic"
                                    variant="outlined"
                                    label="Current Relationship with Family and Friends"
                                    name="relationship_with_family"
                                    onKeyDown={() => {
                                      let obj = [...error];
                                      if (obj[index]?.relationship_with_family) {
                                        delete obj[index]["relationship_with_family"];
                                      }
                                      setError(obj);
                                    }}
                                  />

                                </div>
                                <div className="full_filed password_sec password_sec">
                                  <Typography
                                    variant="subtitle1"
                                    sx={{ color: '#ff9800', fontWeight: 'bold', marginBottom: '10px' }}
                                  >
                                    Current Situations and Challenges
                                  </Typography>

                                  <TextField
                                    value={item.biggest_current_challenges}
                                    onChange={(e) => handelFormData(e, index)}
                                    error={!!error[index]?.biggest_current_challenges}
                                    helperText={error[index]?.biggest_current_challenges}
                                    className="from_input  form_field_wrapperfname"
                                    id="outlined-basic"
                                    variant="outlined"
                                    label="Biggest Current Challenges"
                                    name="biggest_current_challenges"
                                    onKeyDown={() => {
                                      let obj = [...error];
                                      if (obj[index]?.biggest_current_challenges) {
                                        delete obj[index]["biggest_current_challenges"];
                                      }
                                      setError(obj);
                                    }}
                                  />

                                </div>


                                <div style={{ marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                  {/* First Row - Two Columns */}
                                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: '30px', flexWrap: 'wrap' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: '1 1 45%' }}>
                                      <Typography style={{ color: 'white' }}>
                                        Focus on Specific Relationships (Yes/No)
                                      </Typography>
                                      <Switch
                                        checked={item.focus_on_specific_relationships || false}
                                        onChange={(e) =>
                                          handelFormData(
                                            { target: { name: 'focus_on_specific_relationships', value: e.target.checked } },
                                            index
                                          )
                                        }
                                        sx={{
                                          '& .MuiSwitch-switchBase.Mui-checked': {
                                            color: '#ff9800',
                                          },
                                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                            backgroundColor: '#ff9800',
                                          },
                                        }}
                                      />
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: '1 1 45%' }}>
                                      <Typography style={{ color: 'white' }}>
                                        Guidance on Specific Decision/Situation (Yes/No)
                                      </Typography>
                                      <Switch
                                        checked={item.guidance_on_specific_decision || false}
                                        onChange={(e) =>
                                          handelFormData(
                                            { target: { name: 'guidance_on_specific_decision', value: e.target.checked } },
                                            index
                                          )
                                        }
                                        sx={{
                                          '& .MuiSwitch-switchBase.Mui-checked': {
                                            color: '#ff9800',
                                          },
                                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                            backgroundColor: '#ff9800',
                                          },
                                        }}
                                      />
                                    </div>
                                  </div>

                                  {/* Second Row - Two Columns */}
                                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: '30px', flexWrap: 'wrap' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: '1 1 45%' }}>
                                      <Typography style={{ color: 'white' }}>
                                        Concerns About Romantic Life (Yes/No)
                                      </Typography>
                                      <Switch
                                        checked={item.concerns_about_romantic_life || false}
                                        onChange={(e) =>
                                          handelFormData(
                                            { target: { name: 'concerns_about_romantic_life', value: e.target.checked } },
                                            index
                                          )
                                        }
                                        sx={{
                                          '& .MuiSwitch-switchBase.Mui-checked': {
                                            color: '#ff9800',
                                          },
                                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                            backgroundColor: '#ff9800',
                                          },
                                        }}
                                      />
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: '1 1 45%' }}>
                                      <Typography style={{ color: 'white' }}>
                                        Ongoing Projects or Plans (Yes/No)
                                      </Typography>
                                      <Switch
                                        checked={item.ongoing_projects_or_plans || false}
                                        onChange={(e) =>
                                          handelFormData(
                                            { target: { name: 'ongoing_projects_or_plans', value: e.target.checked } },
                                            index
                                          )
                                        }
                                        sx={{
                                          '& .MuiSwitch-switchBase.Mui-checked': {
                                            color: '#ff9800',
                                          },
                                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                            backgroundColor: '#ff9800',
                                          },
                                        }}
                                      />
                                    </div>
                                  </div>

                                  {/* Third Row - Now explicitly creating two columns, even if one is empty */}
                                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: '30px', flexWrap: 'wrap' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: '1 1 45%' }}>
                                      <Typography style={{ color: 'white' }}>
                                        Social Life Fulfillment (Yes/No)
                                      </Typography>
                                      <Switch
                                        checked={item.social_life_fulfillment || false}
                                        onChange={(e) =>
                                          handelFormData(
                                            { target: { name: 'social_life_fulfillment', value: e.target.checked } },
                                            index
                                          )
                                        }
                                        sx={{
                                          '& .MuiSwitch-switchBase.Mui-checked': {
                                            color: '#ff9800',
                                          },
                                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                            backgroundColor: '#ff9800',
                                          },
                                        }}
                                      />
                                    </div>
                                    {/* This empty div acts as the second column for consistent spacing and alignment */}
                                    <div style={{ flex: '1 1 45%' }}></div>
                                  </div>
                                </div>



                                <div style={{ marginTop: '10px', color: 'white' }}> {/* Removed backgroundColor: '#333' */}
                                  {/* Top Section: Spiritual/Personal Growth & Goals for the Reading */}
                                  <div className="full_filed password_sec password_sec">
                                    {/* Spiritual and Personal Growth (Left Column - Top) */}
                                    <div className="password_field_for_perenomial_mandelisom ">
                                      <Typography variant="h6" sx={{ color: '#ff9800', fontWeight: 'bold' }}>
                                        Spiritual and Personal Growth
                                      </Typography>

                                      {/* Spiritual or Personal Growth Practices */}
                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography style={{ color: 'white' }}>
                                          Spiritual or Personal Growth Practices
                                        </Typography>
                                        <Switch
                                          checked={item.spiritualPractices || false}
                                          onChange={(e) =>
                                            handelFormData(
                                              { target: { name: 'spiritualPractices', value: e.target.checked } },
                                              index
                                            )
                                          }
                                          sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                              color: '#ff9800',
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                              backgroundColor: '#ff9800',
                                            },
                                          }}
                                        />
                                      </div>

                                      {/* Exploring Self-Discovery/Personal Development */}
                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography style={{ color: 'white' }}>
                                          Exploring Self-Discovery/Personal Development
                                        </Typography>
                                        <Switch
                                          checked={item.selfDiscovery || false}
                                          onChange={(e) =>
                                            handelFormData(
                                              { target: { name: 'selfDiscovery', value: e.target.checked } },
                                              index
                                            )
                                          }
                                          sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                              color: '#ff9800',
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                              backgroundColor: '#ff9800',
                                            },
                                          }}
                                        />
                                      </div>

                                      {/* Belief in External Influences on Life (Yes/No) */}
                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography style={{ color: 'white' }}>
                                          Belief in External Influences on Life (Yes/No)
                                        </Typography>
                                        <Switch
                                          checked={item.externalInfluences || false}
                                          onChange={(e) =>
                                            handelFormData(
                                              { target: { name: 'externalInfluences', value: e.target.checked } },
                                              index
                                            )
                                          }
                                          sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                              color: '#ff9800',
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                              backgroundColor: '#ff9800',
                                            },
                                          }}
                                        />
                                      </div>
                                    </div>

                                    {/* Goals for the Reading (Right Column - Top) */}
                                    {/* <div className="password_field_for_perenomial_mandelisom ">
                                      <Typography variant="h6" sx={{ color: '#ff9800', fontWeight: 'bold' }}>
                                        Goals for the Reading
                                      </Typography>

                                 
                                      <TextField
                                        value={item.achieveFromReading || ""}
                                        onChange={(e) => handelFormData(e, index)}
                                        error={!!error[index]?.achieveFromReading}
                                        helperText={error[index]?.achieveFromReading}
                                        className="from_input form_field_wrapperfname"
                                        id="outlined-basic"
                                        variant="outlined"
                                        label="achieve From Reading"
                                        name="achieveFromReading"
                                        onKeyDown={() => {
                                          let obj = [...error];
                                          if (obj[index]?.achieveFromReading) {
                                            delete obj[index]["achieveFromReading"];
                                          }
                                          setError(obj);
                                        }}
                                      />

                                    
                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography style={{ color: 'white' }}>
                                          Specific Questions/Topics to Address
                                        </Typography>
                                        <Switch
                                          checked={item.specificQuestions || false}
                                          onChange={(e) =>
                                            handelFormData(
                                              { target: { name: 'specificQuestions', value: e.target.checked } },
                                              index
                                            )
                                          }
                                          sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                              color: '#ff9800',
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                              backgroundColor: '#ff9800',
                                            },
                                          }}
                                        />
                                      </div>

                                     
                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography style={{ color: 'white' }}>
                                          Goals or Outcomes for the Reading
                                        </Typography>
                                        <Switch
                                          checked={item.goalsOutcomes || false}
                                          onChange={(e) =>
                                            handelFormData(
                                              { target: { name: 'goalsOutcomes', value: e.target.checked } },
                                              index
                                            )
                                          }
                                          sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                              color: '#ff9800',
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                              backgroundColor: '#ff9800',
                                            },
                                          }}
                                        />
                                      </div>

                                      
                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography style={{ color: 'white' }}>
                                          Preference for Practical Advice vs. Spiritual Insights
                                        </Typography>
                                        <Switch
                                          checked={item.practicalSpiritualPref || false}
                                          onChange={(e) =>
                                            handelFormData(
                                              { target: { name: 'practicalSpiritualPref', value: e.target.checked } },
                                              index
                                            )
                                          }
                                          sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                              color: '#ff9800',
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                              backgroundColor: '#ff9800',
                                            },
                                          }}
                                        />
                                      </div>
                                    </div> */}
                                  </div>

                                  {/* Separator Line (if desired, otherwise just adjust margin-bottom above) */}
                                  <hr style={{ borderColor: '#555', margin: '30px 0' }} />
                                </div>

                                {/* Bottom Section: Current Situation & Additional Information */}
                                <div className="full_filed password_sec password_sec">
                                  {/* Current Situation (Left Column - Bottom) */}
                                  <div className="password_field_for_perenomial_mandelisom ">
                                    <Typography variant="h6" sx={{ color: '#ff9800', fontWeight: 'bold', marginBottom: '10px' }}>
                                      Current Situation
                                    </Typography>
                                    <TextField
                                      value={item.mainConcern || ""}
                                      onChange={(e) => handelFormData(e, index)}
                                      error={!!error[index]?.mainConcern}
                                      helperText={error[index]?.mainConcern}
                                      className="from_input form_field_wrapperfname"
                                      id="outlined-basic"
                                      variant="outlined"
                                      label="mainConcern"
                                      name="mainConcern"
                                      onKeyDown={() => {
                                        let obj = [...error];
                                        if (obj[index]?.mainConcern) {
                                          delete obj[index]["mainConcern"];
                                        }
                                        setError(obj);
                                      }}
                                    />
                                  </div>

                                  {/* Additional Information (Right Column - Bottom) */}
                                  <div className="password_field_for_perenomial_mandelisom ">
                                    <Typography variant="h6" sx={{ color: '#ff9800', fontWeight: 'bold', marginBottom: '10px' }}>
                                      Additional Information
                                    </Typography>
                                    <TextField
                                      value={item.additionalInfo}
                                      onChange={(e) => handelFormData(e, index)}
                                      error={!!error[index]?.additionalInfo}
                                      helperText={error[index]?.additionalInfo}
                                      className="from_input"
                                      id="additional-info-input"
                                      variant="outlined"
                                      label="Anything Else to Share"
                                      name="additionalInfo"
                                      onKeyDown={() => {
                                        let obj = [...error];
                                        if (obj[index]?.additionalInfo) {
                                          delete obj[index]["additionalInfo"];
                                        }
                                        setError(obj);
                                      }}
                                      multiline
                                      rows={4}
                                    />
                                  </div>
                                </div>





                                <div className="full_filed password_sec password_sec">
                                  <div className="password_field_for_perenomial_mandelisom  ">
                                    <TextField
                                      label="* Password"
                                      variant="outlined"
                                      className="password_field_for_perenomial from_input form_field_wrapperfname"
                                      id="outlined-basic"
                                      name="password"
                                      type={showPass ? "text" : "password"}
                                      value={
                                        item?.password ? item.password : ""
                                      }
                                      onChange={(e) => handelFormData(e, index)}
                                      error={!!error[index]?.password}
                                      helperText={error[index]?.password}
                                      onKeyDown={() => {
                                        let obj = [...error];
                                        if (obj[index]?.password) {
                                          delete obj[index]["password"];
                                        }
                                        setError(obj);
                                      }}
                                    />

                                    <span
                                      className="password_field_for_view"
                                      onClick={() => setShowPass(!showPass)}
                                    >
                                      {showPass ? (
                                        <VisibilityIcon />
                                      ) : (
                                        <VisibilityOffIcon />
                                      )}
                                    </span>
                                  </div>

                                  <div className="password_field_for_perenomial_mandelisom  ">
                                    <TextField
                                      label="* Confirm Password"
                                      className="password_field_for_perenomial from_input form_field_wrapperfname"
                                      id="outlined-basic"
                                      name="confirm_password"
                                      variant="outlined"
                                      type={showConPass ? "text" : "password"}
                                      value={
                                        item?.confirm_password
                                          ? item.confirm_password
                                          : ""
                                      }
                                      onChange={(e) => handelFormData(e, index)}
                                      error={!!error[index]?.confirm_password}
                                      helperText={
                                        error[index]?.confirm_password
                                      }
                                      onKeyDown={() => {
                                        let obj = [...error];
                                        if (obj[index]?.confirm_password) {
                                          delete obj[index]["confirm_password"];
                                        }
                                        setError(obj);
                                      }}
                                    />

                                    <span
                                      className="password_field_for_view"
                                      onClick={() =>
                                        setShowConPass(!showConPass)
                                      }
                                    >
                                      {showConPass ? (
                                        <VisibilityIcon />
                                      ) : (
                                        <VisibilityOffIcon />
                                      )}
                                    </span>
                                  </div>
                                </div>
                                <TextField
                                  style={{ width: "100%" }}
                                  aria-label="minimum height"
                                  className="from_input form_field_wrapperfname textariya_sign_up"
                                  name="additionalInfo"
                                  value={item.additionalInfo}
                                  label="About"
                                  onChange={(e) => handelFormData(e, index)}
                                />
                              </div>


                            </div>
                          );
                        })}

                      <div className="btn_wrpr add_partner_button">
                        <Tooltip title="Add Partner">
                          <IconButton
                            onClick={() => addFields()}
                            disabled={loader}
                          >
                            <AddIcon />
                          </IconButton>
                        </Tooltip>
                      </div>

                      <div className="btn_wrpr payment_form_new">
                        <p className="price_pera_panalium_mendalitiom">
                          Subscription: {amount_and_type.type} - $
                          {amount_and_type.amount}/month
                        </p>

                        <Button type="submit" disabled={loader}>
                          Sign Up
                        </Button>
                      </div>
                    </form>

                    {loader && (
                      <Box sx={{ width: "100%" }}>
                        <LinearProgress />
                      </Box>
                    )}
                  </div>
                </div>
              </Typography>
            </Box>
          </div>
        </Modal>

        <Modal
          open={isStripeModalOpen}
          onClose={handleCloseStripeModal}
          aria-labelledby="stripe-payment-modal-title"
          aria-describedby="stripe-payment-modal-description"
          className="banner_modal_main banner_modal_main_new banner_modal_main_new1"
        >
          <div className="main_wrpr_finddivine main_wrpr_payment_modal">
            <span className="close_btn" onClick={handleCloseStripeModal}>
              <CloseIcon />
            </span>

            <Box className="banner_modal_box_new banner_modal_box_neww">
              <Typography
                id="modal-modal-description" component="div"
                sx={{ mt: 2 }}
                className="modal_banner_new"
              >
                <div className="sub_modal_banner_new">
                  <div className="gred_txt">
                    <h3>
                      <span>Complete Your Payment </span>
                    </h3>
                  </div>

                  <Typography
                    id="stripe-payment-modal-description"
                    sx={{ lineHeight: "30px !important" }}
                    className="price_pera_panalium_mendalitiom"
                  >
                    Subscription: {amount_and_type?.type} - $
                    {amount_and_type?.amount}/month
                  </Typography>

                  {clientSecret && (
                    <Elements options={stripeOptions} stripe={stripePromise}>
                      <StripePaymentModal
                        clientSecret={clientSecret}
                        onSubmit={handleStripeSubmit}
                        processing={stripeProcessing}
                        error={stripeError}
                      />
                    </Elements>
                  )}
                </div>
              </Typography>
            </Box>
          </div>
        </Modal>
      </div>

      <Snackbar
        open={snackbarState}
        autoHideDuration={4000}
        onClose={() => setSnackbarState(false)}
        message={snackbarMassage}
        className="snack_msg"
      />
    </>
  );
};

export default SignUpModal;
